<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper" style="min-height: 307px">
   <div class="col-12">
      <div class="row">
         <div class="col-sm-5">
            <div class="card">
               <div class="card-header bg-info"> ข้อมูลส่วนตัว
                  <div class="card-tools">
                     <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                     </button>
                  </div>
               </div>
               <div class="card-body" *ngFor="let item of userdata">
                  <img src="{{ item.suppic_url }}" alt="suppic" height="300px" *ngIf="item.suppic_url!=NULL">
                  <p>รหัสนสส : {{item.supcode}} </p>
                  <p>ชื่อ-สกุล : {{item.supname}} </p>
                  <p>เบอร์โทรศัพท์ : {{item.tel}}</p>
                  <p>โซน : {{item.zonedata}}</p>
               </div>
            </div>
         </div>

         <div class="col-sm-7">
            <div class="card">
               <div class="card-header bg-warning">
                  แก้ไขข้อมูลส่วนตัว
                  <div class="card-tools">
                     <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                     </button>
                  </div>
               </div>
               <div class="card-body">
                  <ul class="nav nav-pills nav-fill">

                     <li class="nav-item">
                        <a [ngClass]="{'nav-link':true, 'active': tabactive==='tab1'}" aria-current="page"
                           (click)="changetabeditdata(1);">รหัสผ่าน</a>
                     </li>
                     <li class="nav-item">
                        <a [ngClass]="{'nav-link':true, 'active': tabactive==='tab2'}"
                           (click)="changetabeditdata(2);">เบอร์โทรศัพท์</a>
                     </li>
                     <li class="nav-item">
                        <a [ngClass]="{'nav-link':true, 'active': tabactive==='tab3'}"
                           (click)="changetabeditdata(3);">ภาพประจำตัว</a>
                     </li>
                     <!-- <li class="nav-item">
                     <a class="nav-link disabled" tabindex="-1" aria-disabled="true">Disabled</a>
                     </li> -->
                  </ul>
                  <br>
                  <div class="card" [hidden]="changepassword">
                     <div class="card-body">
                        <form [formGroup]="formedit" (ngSubmit)="editpassword();">
                           <label> รหัสผ่านเดิม</label>
                           <input type="password" class="form-control" formControlName="oldpassword" #oldpassword
                              [ngClass]="{ 'is-invalid': submitted && form.oldpassword.errors }"> <br>
                           <div *ngIf="submitted && form.oldpassword.errors?.required" class="invalid-feedback">
                              ต้องกรอกรหัสผ่านเดิม</div>
                           <div class="custom-control custom-checkbox small">
                              <input type="checkbox" class="custom-control-input" id="customCheck"
                                 (click)="oldpassword.type=oldpassword.type == 'password' ? 'text' : 'password'">
                              <label class="custom-control-label" for="customCheck">แสดงรหัสผ่าน</label>
                           </div>
                           <label> รหัสผ่านใหม่</label>
                           <input type="password" class="form-control" formControlName="newpassword" #newpassword
                              [ngClass]="{ 'is-invalid': submitted && form.newpassword.errors }"> <br>
                           <div class="custom-control custom-checkbox small">
                              <input type="checkbox" class="custom-control-input" id="newpassword"
                                 (click)="newpassword.type=newpassword.type == 'password' ? 'text' : 'password'">
                              <label class="custom-control-label" for="newpassword">แสดงรหัสผ่าน</label>
                           </div>
                           <div *ngIf="submitted && form.newpassword.errors?.required" class="invalid-feedback">
                              จำเป็นต้องกรอกรหัสผ่านใหม่</div>
                           <div *ngIf="form.newpassword.errors?.minlength" class="invalid-feedback">
                              รหัสผ่านใหม่ต้องมีอย่างน้อย 4 ตัว
                           </div>
                           <label>ยืนยันรหัสผ่านอีกครั้ง</label>
                           <input type="password" formControlName="confirmpassword" class="form-control"
                              [ngClass]="{ 'is-invalid': submitted && form.confirmpassword.errors }" />
                           <div *ngIf="form.confirmpassword.errors" class="invalid-feedback">
                              <div *ngIf="form.confirmpassword.errors?.required">
                                 จำเป็นต้องกรอกรหัสผ่านใหม่
                              </div>
                              <div *ngIf="form.confirmpassword.errors?.matching">
                                 รหัสผ่านไม่ตรงกัน
                              </div>
                           </div>


                           <hr>
                           <button type="submit" class="btn btn-success">ยืนยัน</button>
                           <button type="button" (click)="onReset()" class="btn btn-warning float-right">Reset</button>
                        </form>
                     </div>
                  </div>

                  <div class="card" [hidden]="changephonenumber">
                     <div class="card-body">
                        <form [formGroup]="formedit" (ngSubmit)="editphonenumber();">
                           <label> เบอร์โทรศัพท์ใหม่ :</label>
                           <input type="text" class="form-control"
                              onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                              formControlName="newphone"
                              [ngClass]="{ 'is-invalid': submitted && form.newphone.errors }">
                           <div *ngIf="submitted && form.newphone.errors?.required" class="invalid-feedback">
                              จำเป็นต้องเบอร์โทรใหม่</div>
                           <div *ngIf="form.newphone.errors?.minlength" class="invalid-feedback">
                              เบอร์โทรใหม่ต้องมีอย่างน้อย 10 ตัว
                           </div>
                           <div *ngIf="form.newphone.errors?.maxlength" class="invalid-feedback">
                              เบอร์โทรใหม่ต้องมี 10 ตัว
                           </div>
                           <hr>
                           <button type="submit" class="btn btn-success">ยืนยัน</button>
                           <button type="button" (click)="onReset()" class="btn btn-warning float-right">Reset</button>
                        </form>
                     </div>
                  </div>
                  <div class="card" [hidden]="changeprofilepic">
                     <div class="card-body">
                        <input class="btn btn-info form-control" type="file" accept="image/png, image/gif, image/jpeg"
                           (change)="onFileUpload($event)">
                        <p style="color: red;">หลังจากบันทึกแล้วภาพจะมีผล ในการเข้าสู่ระบบครั้งถัดไป</p>
                        <hr>
                        <button class="btn btn-success" (click)="editprofirepic();">บันทึก</button>
                     </div>
                  </div>

               </div>
            </div>
         </div>
      </div>

      <!-- <div class="col-md-12">
         <div class="card">
            <div class="card-header bg-success">  ผลสรุป KPI 
               <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                  </button>
               </div>
            </div>
            <div class="card-body">
            
            </div>
         </div>
      </div>
      <div class="col-md-12">
         <div class="card">
            <div class="card-header bg-warning">   กราฟของฉัน 
               <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                  </button>
               </div>
            </div>
            <div class="card-body">
               <div class="row">
                  <div class="col-md-4">
                      <div class="card">
                          <br>
                          <div id="MyArea" style="height: 500px; width: 100%;"></div>
                      </div>
                      
                  </div>
              
                  <br><br> 
                  <div class="col-md-4">
                      <div class="card">
                          <br>
                          <div id="MyTon" style="height: 500px; width: 100%;"></div>
                      </div>
                  </div>

                  <div class="col-md-4">
                      <div class="card">
                          <br>
                          <div id="MyYield" style="height: 500px; width: 100%;"></div>
                      </div>
                  </div>
              </div>
            </div>
         </div>
      </div>
      <div class="col-md-12">
         <div class="card">
            <div class="card-header bg-danger"> ข้อมูลส่วนตัว
               <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse"><i class="fas fa-minus"></i>
                  </button>
               </div>
            </div>
            <div class="card-body">
               
            </div>
         </div>
      </div> -->

   </div>
</div>
<app-footer></app-footer>